import React, { useState } from 'react'
import { Dialog } from 'primereact/dialog';
import BuscarComercio from './Components/BuscarComercio';
import ToLogin from '../../components/misc/Redirect/ToLogin';
import { AceptarTerminos } from '../terminosCondiciones/AceptarTerminos';
import { General } from '../terminosCondiciones/General';

import { ObtenerTyC, aceptarTyC } from '../shared/services/terminosycondiciones.service';
import DashBoard from './Components/DashBoard';
import { useGlobalContext } from '../shared/context/global.context';
import { getComercioById } from './Services/comercio.service';
import { getVerificar } from '../shared/services/verificarCarga.service';
import Spinner from '../shared/components/Spinner';
import { apiLogout } from '../shared/services/logout.service';
import { STORAGE_LOCAL } from '../shared/models/storages';
import { isNullOrEmpty } from '../shared/utilitties/string.utilities';
import { Redirect } from 'react-router';

interface IProps {
  enviarComercios: Function
}
interface IState {
  tycVisible: boolean,
  loadingTyC: boolean
}

const Home = (props: IProps) => {
  const { buscarComercio, setBuscarComercio, comercioSelecionado, setComercioSelecionado, verificarCarga } = useGlobalContext()
  const [tyc, setTyc] = useState<IState>({ tycVisible: false, loadingTyC: true });
  const [redirect, setRedirect] = useState<any>({ redirect: false, url: "" });
  const [urlEmail, setUrlEmail] = useState<string | null>(null);
  const [finishLoadPage, setFinishLoadPage] = useState(true);

  React.useEffect(() => {
    if (isNullOrEmpty(urlEmail!)) setUrlEmail(window.localStorage.getItem(STORAGE_LOCAL.EMAIL_DIRECTED));
  }, []);

  React.useEffect(() => {
    if (verificarCarga.comerciosString === "-1") return
    getInitial();

  }, [verificarCarga]);

  async function getInitial() {
    await verificar();
    await tycVerify();
    setFinishLoadPage(false)
  }

  const searchComercio = async (idComercio: string) => {
    const { data, status } = await getComercioById(idComercio)
    if (status === 200) {
      setComercioSelecionado(data.comercios)
    }
  }

  const verificar = async () => {
    const { data, status } = await getVerificar()
    if (status === 200) {
      if (data.comerciosString === "" || data.comerciosString.split(',').length > 1) {
        setBuscarComercio(true)
      } else
        if (data.comerciosString && comercioSelecionado.length === 0) {
          searchComercio(data.comerciosString)
        } else {
          let result = data;
          if (result.nologin != undefined && result.nologin.indexOf("http") > -1) {
            setRedirect({ redirect: true, url: result.nologin });
          }
          else if (!result.error) {
            if (result.comerciosString && !result.todos) {
              searchComercio(result.comerciosString)
            }
          }
        }
    } else {
      console.log("Home, algo salio mal")
    }
  };



  const tycVerify = async () => {
    //const result = await ObtenerTyC()
    const result = { "tyC": true, "success": true, "error": null, "errorList": null }
    if (result.success) { setTyc({ tycVisible: !result.tyC, loadingTyC: false }) };
  }


  const onAcceptar = async () => {
    const result = await aceptarTyC()
    if (result.status === 200)
      setTyc({ ...tyc, tycVisible: false });
  }

  const onCancelar = async () => {
    const { data, status } = await apiLogout()
    if (status === 200) {
      setRedirect({ redirect: true, url: data.nologin });
    }
  }

  function onHide() {
    onCancelar();
  }

  if (finishLoadPage) return <Spinner />
  else if (redirect.redirect) return (<ToLogin url={redirect.url} tyc={true} />)
  else if (buscarComercio) return <BuscarComercio />;
  else if (tyc.tycVisible)
    return (<Dialog
      header="Terminos y Condiciones"
      style={{ width: '60vw' }}
      visible={tyc.tycVisible}
      onHide={onHide}
      blockScroll>
      <AceptarTerminos componente={<General />} onAcceptar={onAcceptar} onCancelar={onCancelar} />
    </Dialog>);
  else if (!isNullOrEmpty(urlEmail!)) {
    return <Redirect to={urlEmail!} />;
  }
  else
    return <DashBoard />;
}

export default Home